<template>
  <div class="main">
    <div class="file">
      <h4>压缩包上传 <span>（仅支持上传<span>zip</span>格式文件压缩包）</span></h4>
      <div class="zip">
        <img src="/static/icon/zip.png" alt="" />
        <span v-if="zipStatus == 'selected'">已选择</span>
        <span v-if="zipStatus == 'uploading'">上传中</span>
        <span v-if="zipStatus == 'finished'">已上传</span>
        <input
          :style="name ? 'z-index: -1;' : ''"
          @change="get_zip"
          type="file"
          title=" "
          ref="inp"
          multiple
          accept="application/zip,application/rar"
        />
      </div>
      <span style="font-size: 0.3rem">{{ name }}</span>
      <b v-if="name" @click="deleta_zip">清空</b>
    </div>
    <p>提示：若病情资料、图片较多，请打包上传</p>
  </div>
</template>

<script>
/* eslint-disable */
import { Indicator } from 'mint-ui'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      name: '',
      zipPath: []
    }
  },
  computed: {
    ...mapState({
      zipStatus: (state) => state.zipstore.zip_status,
      zipStore: (state) => state.zipstore.zip_upload_cache
    })
  },
  methods: {
    get_zip(e) {
      this.name = e.target.files[0].name
      console.log(e.target.files[0].name)
      this.file = e.target.files[0]
      this.$store.commit('set_zip_upload_cache', this.file) // 存储文件缓存
      this.$store.commit('set_zip_status', 'selected') // 更新文件上传状态
    },
    funUploadFile() {
      this.$store.commit('set_zip_status', 'uploading')
      let vm = this
      Indicator.open()
      this.axiosBaseApi
        .get('https://fc.yndyt.net/policy?bucket_name=inquiry-ol')
        .then((res) => {
          if (res.status === 200) {
            const post = res.data
            const type = this.file.name.substr(this.file.name.indexOf('.') + 1)
            const obj = String(new Date().getTime()) + String(Math.floor(Math.random() * 10000))
            const storeAs = `Uploads/zip/${obj}.${type}`
            const form = new FormData()
            form.append('name', post.name)
            form.append('key', storeAs)
            form.append('OSSAccessKeyId', post.ossKeyId)
            form.append('policy', post.policy)
            form.append('signature', post.sign)
            form.append('success_action_status', '200')
            form.append('file', this.file)
            this.axiosBaseApi
              .post('https://inquiry.ynhdkc.com', form)
              .then((result) => {
                vm.zipPath.push(storeAs)
                vm.$store.commit('set_zip_paths', vm.zipPath) // 存储返回的地址
                vm.$store.commit('set_zip_status', 'finished') // 更新文件上传状态
                Indicator.close()
              })
              .catch((err) => {
                Indicator.close()
                alert('文件上传失败，请重新上传！')
                vm.zipPath = []
              })
          } else {
            Indicator.close()
            vm.$toast(res.statusText)
          }
        })
        .catch((e) => {
          Indicator.close()
          vm.$toast(e)
        })
    },
    deleta_zip() {
      this.name = ''
      this.$store.commit('set_zip_upload_cache', [])
      this.$store.commit('set_zip_paths', [])
      this.$refs.inp.value = ''
    }
  },
  destroyed() {
    this.$store.commit('set_zip_upload_cache', [])
    this.$store.commit('set_zip_upload_cache_compress', [])
    this.$store.commit('set_zip_upload_cache_origin', [])
    this.$store.commit('set_zip_paths', [])
  },
  watch: {
    zipStatus() {
      if (this.zipStatus === 'uploading') {
        this.funUploadFile()
      }
    },
    zipStore() {
      if (this.zipStore.length <= 0) {
        this.$store.commit('set_zip_status', 'ready') // 更新文件上传状态
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.main {
  width: 100%;
  position: relative;
  min-height: 3rem;
  border-top: 2px solid #f7f7f7;
  padding: 20px 0;
  .file {
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    position: relative;
    h4 {
      font-size: 0.4rem;
      margin-bottom: 0.2rem;
      color: #4d4d4d;
      span {
        font-size: 0.32rem;
        color: #000;
        background: #fff;
        span {
          color: #ff6666;
          font-size: 0.35rem;
          font-weight: 600;
        }
      }
    }
    .zip {
      width: 80px;
      height: 80px;
      position: relative;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
      input {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        height: 100%;
        opacity: 0;
      }
      span {
        width: 100%;
        position: absolute;
        top: 0.9rem;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
      }
    }
    > span {
      position: absolute;
      left: 120px;
      top: 1rem;
      font-size: 0.4rem !important;
    }
    b {
      position: absolute;
      right: 1rem;
      top: 1rem;
      background: #35b6a4;
      color: #fff;
      border-radius: 3px;
      padding: 0.05rem 0.2rem;
    }
  }
  > p {
    margin-top: 0.25rem;
    color: #ff6666;
    margin-left: 5%;
  }
}
</style>
